"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useFilesState = function (initFiles) {
    var _a = (0, react_1.useState)(initFiles), files = _a[0], setFiles = _a[1];
    var onAddFile = (0, react_1.useCallback)(function (event) {
        if (event) {
            var files_1 = event.target.files;
            setFiles(function (prevFiles) {
                if (prevFiles === void 0) { prevFiles = []; }
                var newFiles = __spreadArray([], prevFiles, true);
                if (files_1 && files_1[0]) {
                    newFiles.push(files_1[0]);
                }
                return newFiles;
            });
        }
    }, [setFiles]);
    var onDeleteFile = (0, react_1.useCallback)(function (index) {
        setFiles(function (prevFiles) {
            if (prevFiles === void 0) { prevFiles = []; }
            var newFiles = __spreadArray([], prevFiles, true);
            newFiles === null || newFiles === void 0 ? void 0 : newFiles.splice(index, 1);
            return newFiles;
        });
    }, [setFiles]);
    var resetFiles = (0, react_1.useCallback)(function () {
        setFiles(undefined);
    }, [setFiles]);
    return [files, onAddFile, onDeleteFile, setFiles, resetFiles];
};
exports.default = useFilesState;
